import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslocoModule } from '@ngneat/transloco';
import { firstValueFrom } from 'rxjs';
import { EndpointsService } from '../../modules/admin/endpoints/endpoints.service';
import { ContractWorkSummaryRow } from '../../modules/admin/endpoints/endpoints.types';
import { Net2BeepleLocator } from '../../core/dtype/dtype.types';
import { ToggleHourBagRequest } from '../../core/http/request.model';

@Component({
    selector: 'app-worker-hour-bag-dialog',
    imports: [MatButtonModule, MatIconModule, TranslocoModule],
    templateUrl: './worker-hour-bag-dialog.component.html',
    styleUrls: ['./worker-hour-bag-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkerHourBagDialogComponent {

    private readonly dialogRef = inject(MatDialogRef<WorkerHourBagDialogComponent>);
    private readonly endpointsService = inject(EndpointsService);
    private readonly snackBar = inject(MatSnackBar)
    public data: { row: ContractWorkSummaryRow, locator: Net2BeepleLocator } = inject(MAT_DIALOG_DATA);

    public isHourBagActive = signal<boolean>(false);




    async approve() {
        const newValue = !this.isHourBagActive();

        const request: ToggleHourBagRequest = {
            contractMonthlyOid: this.data.row.oid,
            active: newValue,
            locator: this.data.locator
        };
        if (request){

            const reply = await firstValueFrom(this.endpointsService.toggleHourBag(request));
            this.isHourBagActive.set(newValue);
            this.snackBar.open(
                newValue
                    ? 'Bolsa activada correctamente'
                    : 'Bolsa desactivada correctamente',
                undefined,
                { duration: 3000 }
            );
            this.dialogRef.close(reply.row);
        }
    }

    closeDialog() {
        this.dialogRef.close();
    }
}
